module.exports = __webpack_public_path__ + "img/icon-shipment.de5f14f.png";